import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  ContactLeadStatus,
  IContactLead,
  IContactLeadListResponse,
} from '../../_interfaces/IContactLead';

interface ContactLeadFilters {
  page?: number;
  size?: number;
  status?: ContactLeadStatus | 'ALL';
  q?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactLeadsService {
  constructor(private readonly http: HttpClient) {}

  private baseUrl(path = ''): string {
    const suffix = path ? `/${path}` : '';
    return `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/admin/contact-leads${suffix}`;
  }

  getAll(filters: ContactLeadFilters = {}) {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && `${value}`.trim() !== '') {
        params = params.set(key, `${value}`);
      }
    });
    return this.http.get<IContactLeadListResponse>(this.baseUrl(), { params });
  }

  update(id: number, payload: Partial<Pick<IContactLead, 'status' | 'notes'>>) {
    return this.http.patch<IContactLead>(this.baseUrl(`${id}`), payload);
  }
}
